import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Observable} from 'rxjs';
import {Action, select, Store} from '@ngrx/store';
import {filter, flatMap, map, withLatestFrom} from 'rxjs/operators';
import * as actionsUi from './mandantenverwaltung-typspezifikation.actions.ui';
import {PageState} from './mandantenverwaltung-typspezifikation.reducer';
import {UuidService} from '@orga-app/providers/uuid.service';
import {ADMIN_ROLLEN_LADEN, AdminRollenLadenAction, VeranstaltungsTypGewaehlt} from './mandantenverwaltung-typspezifikation.actions.ui';
import {GetMandantConfigAction} from '../../../client-ngrx/api';
import {PandemieConfigTypes} from '../../../client-constants';
import PANDEMIE_TYP_KONFIGURATION_OPTIONS = PandemieConfigTypes.PANDEMIE_VERANSTALTUNG_TYP_KONFIGURATION_MANDANT_OPTIONS;
import {getAdminRollenSelected, getSelectedTyp, getSelectedTypDetail, getSelectedTypFeld, getSelectedTypFelder} from './mandantenverwaltung-typspezifikation.selectors';
import {GetVeranstaltungsTypAdminRollenAction, GetVeranstaltungsTypDetailAction, GetVeranstaltungsTypenAction, GetVeranstaltungsTypFelderAction, PostVeranstaltungsTypAdminRolleEntfernenAction, PostVeranstaltungsTypAdminRollenHinzufuegenAction, PostVeranstaltungsTypAktualisierenAction, PostVeranstaltungsTypAnlegenAction, PostVeranstaltungsTypEntfernenAction, PostVeranstaltungsTypFeldAktualisierenAction, PostVeranstaltungsTypFeldAnlegenAction} from '../../../client-ngrx/veranstaltungstypen';
import {VeranstaltungsTypFeldRequest, VeranstaltungsTypRolleMultiRequest, VeranstaltungsTypRolleRequest, VeranstaltungsTypStammRequest} from '../../../clients/veranstaltungstypen';

@Injectable()
export class MandantenverwaltungTypspezifikationPageUiEffects {

    @Effect()
    pageReset$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.PAGE_STATE_RESET)
        , flatMap(() => {
            return [new GetMandantConfigAction(PANDEMIE_TYP_KONFIGURATION_OPTIONS),
                new GetVeranstaltungsTypenAction()];
        })
    );

    @Effect()
    veranstaltungstypenLaden$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.VERANSTALTUNGS_TYPEN_LADEN)
        , map(() => new GetVeranstaltungsTypenAction())
    );

    @Effect()
    veranstaltungsTyp$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.VERANSTALTUNGS_TYP_GEWAEHLT)
        , flatMap((x: VeranstaltungsTypGewaehlt) => {
            return [new GetVeranstaltungsTypDetailAction(x.payload.veranstaltungstyp_id),
                new GetVeranstaltungsTypAdminRollenAction(x.payload.veranstaltungstyp_id),
                new GetVeranstaltungsTypFelderAction(x.payload.veranstaltungstyp_id)];
        })
    );

    @Effect()
    veranstaltungsTypEntfernen$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.VERANSTALTUNGS_TYP_ENTFERNEN)
        , withLatestFrom(this.store.pipe(select(getSelectedTyp)))
        , filter(([x, selectedTyp]) => {
            // console.log('SelectedTyp: ', selectedTyp);
            return (selectedTyp !== null);
        } )
        , map(([x, selectedTyp]) => {
            return new PostVeranstaltungsTypEntfernenAction({
                veranstaltungstyp_id: selectedTyp.veranstaltungstyp_id,
            });
        })
    );

    @Effect()
    veranstaltungsTypSpeichern$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.VERANSTALTUNGS_TYP_SPEICHERN)
        , withLatestFrom(this.store.pipe(select(getSelectedTypDetail)),
            this.store.pipe(select(getSelectedTypFelder)))
        , map(([x, typStamm, felder]) => {

            let anzeigeFeld1 = typStamm.anzeige_feld_1;
            let anzeigeFeld2 = typStamm.anzeige_feld_2;
            let anzeigeFeld3 = typStamm.anzeige_feld_3;

            felder.forEach(feld => {
                if (anzeigeFeld1 !== null && anzeigeFeld1 !== undefined && anzeigeFeld1.search('{{' + feld.item.titel + '}}') > -1) {
                    anzeigeFeld1 = anzeigeFeld1.replace('{{' + feld.item.titel + '}}', '{{' + feld.item.feld_id + '}}');
                }
                if (anzeigeFeld2 !== null && anzeigeFeld2 !== undefined && anzeigeFeld2.search('{{' + feld.item.titel + '}}') > -1) {
                    anzeigeFeld2 = anzeigeFeld2.replace('{{' + feld.item.titel + '}}', '{{' + feld.item.feld_id + '}}');
                }
                if (anzeigeFeld3 !== null && anzeigeFeld3 !== undefined && anzeigeFeld3.search('{{' + feld.item.titel + '}}') > -1) {
                    anzeigeFeld3 = anzeigeFeld3.replace('{{' + feld.item.titel + '}}', '{{' + feld.item.feld_id + '}}');
                }
            });

            const request: VeranstaltungsTypStammRequest = {
                anzeige_feld_1: anzeigeFeld1,
                anzeige_feld_2: anzeigeFeld2,
                anzeige_feld_3: anzeigeFeld3,
                bezeichnung: typStamm.bezeichnung,
                veranstaltungstyp_id: typStamm.veranstaltungstyp_id,
                ist_aktionen_sichtbar: typStamm.ist_aktionen_sichtbar,
                ist_beginn_sichtbar: typStamm.ist_beginn_sichtbar,
                ist_einlass_sichtbar: typStamm.ist_einlass_sichtbar,
                ist_deaktiviert: typStamm.ist_deaktiviert,
                ist_veranstaltungsleitung_sichtbar: typStamm.ist_veranstaltungsleitung_sichtbar,
                ist_beobachter_sichtbar_report: typStamm.ist_beobachter_sichtbar_report,
                ist_veranstaltungsleitung_sichtbar_report: typStamm.ist_veranstaltungsleitung_sichtbar_report,
                beginn_text: typStamm.beginn_text,
                beobachter_text: typStamm.beobachter_text,
                veranstaltungsleiter_text: typStamm.veranstaltungsleiter_text,
                einlass_text: typStamm.einlass_text,
                ist_auswahl_nur_diensthabende: typStamm.ist_auswahl_nur_diensthabende,
                ist_fb_admin_zugriff: typStamm.ist_fb_admin_zugriff,
                ist_aufgabe_neutral_text_optional: typStamm.ist_aufgabe_neutral_text_optional,
                ist_aufgabe_nichtok_text_optional: typStamm.ist_aufgabe_nichtok_text_optional,
            };

            if (typStamm.veranstaltungstyp_id !== null && typStamm.veranstaltungstyp_id !== undefined) {
                // aktualisieren
                return new PostVeranstaltungsTypAktualisierenAction(request);
            } else {
                // anlegen
                request.veranstaltungstyp_id = this.uuid.generateUUID();
                return new PostVeranstaltungsTypAnlegenAction(request);
            }
        })
    );

    // Berechtigungen
    @Effect()
    adminRollenLaden$: Observable<Action> = this.actions$.pipe(
        ofType<AdminRollenLadenAction>(ADMIN_ROLLEN_LADEN)
        , withLatestFrom(this.store.pipe(select(getSelectedTyp)))
        , filter(([x, verTyp]) => verTyp !== undefined && verTyp !== null)
        , map(([x, verTyp]) => {
            return new GetVeranstaltungsTypAdminRollenAction(verTyp.veranstaltungstyp_id);
        })
    );

    @Effect()
    adminRollenLoeschen$: Observable<Action> = this.actions$.pipe(
        ofType<actionsUi.AdminRollenLoeschenAction>(actionsUi.ADMIN_ROLLEN_LOESCHEN)
        , withLatestFrom(this.store.pipe(select(getSelectedTyp)),
            this.store.pipe(select(getAdminRollenSelected)))
        , flatMap(([x, verTyp, selRollen]) => {
            const actions = [];
            selRollen.forEach(rolleId => {
                const request = <VeranstaltungsTypRolleRequest>{
                    veranstaltungstyp_id: verTyp.veranstaltungstyp_id,
                    rolle_id: rolleId,
                };
                actions.push(new PostVeranstaltungsTypAdminRolleEntfernenAction(request));
            });

            return actions;
        }));

    @Effect()
    adminRollenHinzufuegen$: Observable<Action> = this.actions$.pipe(
        ofType<actionsUi.AdminRollenHinzufuegenAction>(actionsUi.ADMIN_ROLLEN_HINZUFUEGEN)
        , withLatestFrom(this.store.pipe(select(getSelectedTyp)))
        , map(([x, verTyp]) => {
            const request = <VeranstaltungsTypRolleMultiRequest>{
                veranstaltungstyp_id: verTyp.veranstaltungstyp_id,
                rolle_ids: x.payload,
            };
            return new PostVeranstaltungsTypAdminRollenHinzufuegenAction(request);
        }));

    @Effect()
    veranstaltungsTypFeldSpeichern$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.VERANSTALTUNGS_TYP_FELD_SPEICHERN)
        , withLatestFrom(this.store.pipe(select(getSelectedTypFeld)),
            this.store.pipe(select(getSelectedTyp)))
        , map(([x, typFeld, selTyp]) => {
            const request: VeranstaltungsTypFeldRequest = {
                feld_id: typFeld.feld_id,
                titel: typFeld.titel,
                ist_deaktiviert: typFeld.ist_deaktiviert,
                typ: typFeld.typ,
                parent_feld_id: typFeld.parent_feld_id,
                format: typFeld.format,
                select_options: typFeld.select_options,
                veranstaltungstyp_id: selTyp.veranstaltungstyp_id
            };
            if (typFeld.feld_id !== undefined && typFeld.feld_id !== null && typFeld.feld_id !== '') {
                // aktualisieren
                return new PostVeranstaltungsTypFeldAktualisierenAction(request);
            } else {
                // anlegen
                request.feld_id = this.uuid.generateUUID();
                return new PostVeranstaltungsTypFeldAnlegenAction(request);
            }
        })
    );

    constructor(private actions$: Actions,
                private store: Store<PageState>,
                private uuid: UuidService) {
    }
}
